import { render } from "./TermAndConditionView.vue?vue&type=template&id=703baa23"
import script from "./TermAndConditionView.vue?vue&type=script&lang=js"
export * from "./TermAndConditionView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__